<template>
    <div>

        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow border-0">
                        <div  style="min-height: 600px;">
                                <h2 class="sentrao">🔥 Productos recomendados 🔥</h2>
                                <div class="dropdown-divider"></div>

                                <h3 class="sentrao">Musculación</h3>
                                <a href="https://amzn.to/2WN0xJA" class="afiliado">
                                    <stats-card title="OneTwoFit Banco de Musculación Plano"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/61kUhwd%2BiFL._AC_SL1000_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/2WN0xJA</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <a href="https://amzn.to/3lPxHCj" class="afiliado">
                                    <stats-card title="HOMCOM Banco de Pesas Plegable"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/61ixjYQ2k3L._AC_SL1500_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/3lPxHCj</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <a href="https://amzn.to/37RLzYU" class="afiliado">
                                    <stats-card title="HOMCOM Soporte Estante Ajustable Barra Levantamiento Pesas"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/61iWOP2AEcL._AC_SL1500_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/37RLzYU</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <a href="https://amzn.to/3glApOM" class="afiliado">
                                    <stats-card title="Bowflex SelectTech - Mancuernas Ajustables"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/91a6%2Be6FNYL._AC_SL1500_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/3glApOM</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <a href="https://amzn.to/2VJxSoe" class="afiliado">
                                    <stats-card title="WOTEK Bandas Elasticas Musculacion"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/71gfjULq1SL._AC_SL1500_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/2VJxSoe</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <div class="dropdown-divider"></div>

                                <h3>Accesorios</h3>

                                <a href="https://amzn.to/2Lgqb6X" class="afiliado">
                                    <stats-card title="ARMAGEDDON SPORTS Cinturón Musculación"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/811L6L%2BWEzL._AC_SL1500_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/2Lgqb6X</span>
                                    </template>
                                    </stats-card>
                                </a>

                                <a href="https://amzn.to/2VOiQgQ" class="afiliado">
                                    <stats-card title="8cplus EMG120 Block Chalk 120g 12 pastillas"
                                            type="gradient-red"
                                            sub-title=""
                                            icon="ni ni-active-40"
                                            class="mb-4 mb-xl-0">
                                    
                                    <template slot="footer">
                                        <img class="afiliado_image" src="https://images-na.ssl-images-amazon.com/images/I/41XCdi0G4yL._AC_.jpg" alt="">
                                        <span class="text-warning mr-2"> Enlace:</span>
                                        <span @click="track" class="text-nowrap">https://amzn.to/2VOiQgQ</span>
                                    </template>
                                    </stats-card>
                                </a>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    methods: {
        track() {
            this.$gtag.event("link_to_affiliate", {
            'event_category': "money",
            'event_label': "link_to_affiliate",
            'value': 1
            })
        },
    }
  }
</script>
<style>
    .afiliado{
        margin: 30px;
        border: 20px;
        padding: 20px;
    }
    .afiliado_image{
        max-height: 128px;
    }
    .sentrao{
        text-align: center;
    }
</style>
